import React from "react";
import { RouteComponentProps } from "react-router-dom";
import queryString from "query-string";
import FeedbackListContainer from "../../Feedback/Components/Common/FeedbackList/FeedbackListContainer";
import { FeedbackCategory, FeedbackSortOption } from "../../Feedback/Constants/feedbackEnums";
import { SearchContextType } from "../../Layout/Constants/LayoutEnums";
import { SearchContext } from "../../Layout/Models/SearchContext";
import { SearchbarContext } from "../SearchbarContext";

type TParams = {
  query?: string;
  context?: SearchContextType;
  contextItemId?: string;
};

type State = {
  query?: string;
  context?: SearchContextType;
  contextItemId?: string;
};

class SearchResultsContainer extends React.Component<RouteComponentProps, State> {
  constructor(props: RouteComponentProps) {
    super(props);

    const params: TParams = queryString.parse(props.location.search);

    this.state = {
      query: params.query,
      context: params.context,
      contextItemId: params.contextItemId
    };
  }

  componentDidUpdate() {
    const params: TParams = queryString.parse(this.props.location.search);

    if (
      this.state.query !== params.query ||
      this.state.context !== params.context ||
      this.state.contextItemId !== params.contextItemId
    ) {
      this.setState((prevState: State) => {
        return {
          ...prevState,
          query: params.query,
          context: params.context,
          contextItemId: params.contextItemId
        };
      });
    }
  }

  render() {
    const context: SearchContext = {
      type: this.state.context ? this.state.context : SearchContextType.All,
      itemId: this.state.contextItemId
    };

    return (
      <div>
        <h2>Search Results</h2>
        <SearchbarContext.Consumer>
          {searchContext => (
            <FeedbackListContainer
              listId="SEARCH_RESULTS_LIST"
              sort={FeedbackSortOption.DateCreated}
              searchQuery={searchContext.searchQuery}
              context={searchContext.context ? searchContext.context : context}
              reorderable
              fullscreen
              enableDownload
              reloadOnRender={searchContext.shouldReload}
              setReloadFeedback={searchContext.setReloadFeedback}
            />
          )}
        </SearchbarContext.Consumer>
      </div>
    );
  }
}

export default SearchResultsContainer;
